(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('ListObjAndObjType', ListObjAndObjType)
        .factory('ListObjByObjTypeAndFleet', ListObjByObjTypeAndFleet)
        .factory('SetScheduleForAll', SetScheduleForAll);

    SetScheduleForAll.$inject = ['$resource', 'DateUtils'];

    function SetScheduleForAll($resource, DateUtils) {
        var resourceUrl = 'api/tab-schedules/add-more';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.scheduleDatetime = DateUtils.convertLocalDateFromServer(data.scheduleDatetime);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                   // data.scheduleDatetime = DateUtils.convertLocalDateToServer(data.scheduleDatetime);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.scheduleDatetime = DateUtils.convertLocalDateToServer(data.scheduleDatetime);
                    return angular.toJson(data);
                }
            }
        });
    }

    ListObjAndObjType.$inject = ['$resource'];


    function ListObjAndObjType($resource) {
        var resourceUrl = 'api/tab-objects/by-fleet/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                cache: false
            },
            'get': {
                method: 'GET',
                cache: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    ListObjByObjTypeAndFleet.$inject = ['$resource'];


    function ListObjByObjTypeAndFleet($resource) {
        var resourceUrl = 'api/tab-objects/by-obj-type/:typeId/fleet/:fleetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                cache: false
            },
            'filtered': {
                url:'api/tab-objects/by-obj-type/:typeId/fleet/:fleetId/filtered',
                method: 'GET',
                isArray: true
            },
            'update': {method: 'PUT'}
        }, {stripTrailingSlashes: false});
    }

    //TabActionsQueue.$inject = ['$resource'];
    //
    //function TabActionsQueue($resource) {
    //    var resourceUrl = 'api/tab-actions-queues/:id';
    //
    //    return $resource(resourceUrl, {}, {
    //        'query': {
    //            method: 'POST',
    //            isArray: true,
    //            cache: false
    //        }
    //
    //    });
    //}
})();
